import { z } from 'zod';
export const routeParametersWireSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('schema'),
        schema: z.record(z.string(), z.unknown()),
        tokens: z.number(),
        hidden: z.array(z.object({ path: z.string(), reason: z.string() })),
    }),
    z.object({ kind: z.literal('unconvertible'), reason: z.string() }),
]);
const agentConfirmationWireSchema = z.object({
    kind: z.literal('always'),
    shown: z.array(z.string()),
    leftOut: z.array(z.object({ field: z.string(), reason: z.string() })),
});
export const agentConfirmWireSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('never') }),
    agentConfirmationWireSchema,
]);
export const agentExposureWireSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('exposed'),
        description: z.string(),
        confirm: agentConfirmWireSchema.optional(),
        parameters: routeParametersWireSchema,
    }),
    z.object({ kind: z.literal('internal'), reason: z.string() }),
    z.object({ kind: z.literal('untriaged') }),
]);
export const agentGroupWireSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('exposed'), description: z.string() }),
    z.object({ kind: z.literal('internal'), reason: z.string() }),
    z.object({ kind: z.literal('untriaged') }),
]);
const exposureCountsSchema = z.object({
    exposed: z.number(),
    internal: z.number(),
    untriaged: z.number(),
});
export const agentSurfaceOutputSchema = z.object({
    routers: z.array(z.object({
        name: z.string(),
        exposure: agentGroupWireSchema,
        counts: exposureCountsSchema,
        procedures: z.array(z.object({
            name: z.string(),
            path: z.string(),
            type: z.enum(['query', 'mutation', 'subscription', 'unknown']),
            exposure: agentExposureWireSchema,
        })),
    })),
    totals: z.object({
        routers: exposureCountsSchema,
        procedures: exposureCountsSchema,
        everyTurnTokens: z.number(),
        toolHelpTokens: z.number(),
    }),
});
//# sourceMappingURL=agentSurface.js.map